import { Controller } from "remult";

@Controller("volunteer-org-activity-domain-methods")
export class VolunteerOrgActivityDomainMethods {}
